import { renderer } from "lib/dataentry/lib/dataentryform/formitems/resolver";
import isFieldHidden from "data/util/isFieldHidden";

const Kids = (props) =>
    props.descriptor.childItems && props.descriptor.childItems.length
        ? props.descriptor.childItems
            .filter(desc =>
                !desc.type.endsWith("Field") || !isFieldHidden(props.activeRecord.entityKey, desc.key))
            .map(desc =>
                renderer({...props, descriptor: desc}))
        : null;

export default Kids;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Kids.js